import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {

  private readonly KEY = 'qbs-theme';

  get isDark(): boolean {
    return document.documentElement.getAttribute('data-theme') === 'dark';
  }

  init(): void {
    const stored = localStorage.getItem(this.KEY);
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    this.apply(stored ? stored === 'dark' : prefersDark);
  }

  toggle(): void {
    this.apply(!this.isDark);
  }

  private apply(dark: boolean): void {
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
    localStorage.setItem(this.KEY, dark ? 'dark' : 'light');
  }
}
